import Vue, { ComponentOptions } from 'vue';
import { useGlobalState } from './store';
import { useDialog } from './composables/useDialog';
import { useMobileDetection } from './composables/useMobileDetection';
import VideoPlayer from './components/VideoPlayer.vue';
import './support/mixins';
import './bootstrap';
import { useGtm } from './composables/useGtm';
import asset from './utils/asset';

const dialogManager = useDialog();

dialogManager.register({
	'newsletter': () => import('./components/NewsletterDialog.vue'),
	'magazine': () => import('./components/DownloadMagazine.vue'),
	'video-player': VideoPlayer
})

const state = useGlobalState();
const { isMobile } = useMobileDetection();

Vue.config.ignoredElements = [/^x-/];
Vue.config.productionTip = false;
// Vue.config.devtools = false;
Vue.prototype.$gtm = useGtm();
Vue.prototype.$asset = asset;

const baseMixin: ComponentOptions<Vue> = {
	data() {
		return {
			$state: state,
			$isMobile: isMobile
		}
	}
}

export function initVue(options: ComponentOptions<Vue>) {
	new Vue({
		el: options.el || '#tdapp',
		mixins: [baseMixin],
		...options,
	})
}
